import { sameEntityId } from './planningNormalizers';

export const applyPlanningRelationChange = (draft, field, value, references) => {
  const next = { ...draft, [field]: value || null };
  if (field === 'projectId') {
    const realization = references.realizations.find((row) => sameEntityId(row.id, value));
    next.taskId = null;
    next.deliverableId = null;
    next.clientId = realization?.clientId || realization?.companyId || null;
  }
  return next;
};
